<template>
    <Component
        :is="component"
        :to="link"
        :rel="link ? 'nofollow noopener noreferrer' : null"
        :target="link ? '_blank' : null"
        :class="[
            {
                'border-transparent hover:border-accent-100 hover:bg-ash-200 hover:text-accent-700':
                    variant === 'filled',
                'bg-accent-600/50':
                    variant === 'filled' && backgroundTransparent,
                'bg-accent': variant === 'filled' && !backgroundTransparent,
                'border-ash-200 text-ash-200 hover:bg-ash-200 hover:text-accent-700':
                    variant === 'outline',

                'rounded-12 p-[0.3125rem]': iconSize === 'md',
                'rounded-full p-3': iconSize === 'sm',
            },
        ]"
        class="relative inline-block overflow-hidden border transition-all duration-300">
        <div
            :class="{ 'hover:opacity-1 opacity-0': variant === 'outline' }"
            class="bg-noise absolute left-0 top-0 h-full w-full transition-opacity duration-300" />
        <div class="relative">
            <AtomIcon
                :name="icon"
                :class="iconSize === 'sm' ? 'size-5' : 'size-9'" />
        </div>
    </Component>
</template>

<script setup lang="ts">
import type { PropType } from 'vue'

import AtomIcon from '~/components/atom/atom-icon/AtomIcon.vue'
import type { TAtomIcon } from '~/components/atom/atom-icon/atom-icon.types'

const props = defineProps({
    link: {
        type: String as PropType<string>,
        default: null,
    },
    icon: {
        type: String as PropType<TAtomIcon>,
        required: true,
    },
    iconSize: {
        type: String as PropType<'sm' | 'md'>,
        default: 'md',
    },
    variant: {
        type: String as PropType<'filled' | 'outline'>,
        default: 'filled',
    },
    size: {
        type: String as PropType<string>,
        default: 'medium',
    },
    backgroundTransparent: {
        type: Boolean as PropType<boolean>,
        default: false,
    },
})

const component = computed(() => {
    return props.link ? resolveComponent('NuxtLink') : 'button'
})
</script>
